import { render, staticRenderFns } from "./tab2.vue?vue&type=template&id=f776d866&scoped=true"
import script from "./tab2.vue?vue&type=script&lang=js"
export * from "./tab2.vue?vue&type=script&lang=js"
import style0 from "./tab2.vue?vue&type=style&index=0&id=f776d866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f776d866",
  null
  
)

export default component.exports